import { useCallback, useState } from 'react';
import useResizeObserver from './useResizeObserver';

export default function useElementWidth(element?: HTMLElement) {
  const [width, setWidth] = useState(0);

  const updateWidth = useCallback(
    () => setWidth(element?.clientWidth || 0),
    [element],
  );

  useResizeObserver(element, updateWidth);

  return width;
}
